import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  FormController, TextField, Typography
} from '@one-thd/sui-atomic-components';
import { SelectableRadioCard } from '../shared/SelectableRadioCard';
import { NEW_QUOTE_OPTION, QUOTE_NAME_MAX_LENGTH } from '../shared/Constants';
import { getQuoteNameError } from '../../utils/helpers';

const CreateNewQuoteCard = ({ selected, onQuoteNameChange }) => {
  const [quoteName, setQuoteName] = useState('');
  const [quoteNameError, setQuoteNameError] = useState(null);

  const handleQuoteNameInputChange = (value) => {
    const updatedValue = typeof value === 'string' ? value.slice(0, QUOTE_NAME_MAX_LENGTH) : '';
    const validationError = getQuoteNameError(updatedValue);
    setQuoteName(updatedValue);
    setQuoteNameError(validationError);
    onQuoteNameChange(updatedValue, validationError);
  };

  return (
    <div className="sui-mb-2" data-testid="create-new-quote-card">
      <Typography weight="bold">Create a New Quote</Typography>
      <div className="sui-mt-2">
        <SelectableRadioCard value={NEW_QUOTE_OPTION} selected={selected} label="New Quote">
          <FormController className="sui-p-1 sui-pt-0" fullWidth>
            <TextField
              fullWidth
              id="create-quote-input"
              InputProps={{
                'aria-label': 'Quote Name'
              }}
              placeholder="Quote Name"
              value={quoteName}
              onChange={(evt) => handleQuoteNameInputChange(evt?.target?.value)}
              status={quoteNameError ? 'error' : null}
              statusMessage={quoteNameError}
            />
          </FormController>
        </SelectableRadioCard>
      </div>
    </div>
  );
};

CreateNewQuoteCard.propTypes = {
  selected: PropTypes.bool,
  onQuoteNameChange: PropTypes.func
};

CreateNewQuoteCard.defaultProps = {
  selected: false,
  onQuoteNameChange: () => {}
};

CreateNewQuoteCard.displayName = 'CreateNewQuoteCard';

export { CreateNewQuoteCard };
